import React from 'react'
import { NavLink } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { faArrowLeft, faDownload } from '@fortawesome/free-solid-svg-icons'

import Button from 'components/Button'
import useMerchantTransactions from './useMerchantTransaction'
import { ExportToCSV, ExportToPDF } from './utils-actions';

function TransactionsReportFilter(): React.ReactElement {
  const { traderId } = useParams()
  const { merchantTransaction, merchantTransactionLoading } = useMerchantTransactions()

  return (
    <div className="flex flex-wrap items-end mt-4 mb-5 gap-2">
      <Button
        type="button"
        icon={faArrowLeft}
        className="ml-1 rounded-lg"
        iconRight={false}
      > 
        <NavLink to={`/merchant-profile/${traderId}/transactions`} >
          <span className="tracking-wider font-bold">Back</span>
        </NavLink>
      </Button>

      <Button 
      type="button"
      icon={faDownload}
      className="ml-1 rounded-lg"
      iconRight={false}
      onClick={ExportToPDF}
      disabled={merchantTransactionLoading ? true : false}
      >
        Download PDF
      </Button>

      <Button 
      type="button"
      icon={faDownload}
      className="ml-1 rounded-lg"
      iconRight={false}
      onClick={() => ExportToCSV(merchantTransaction)}
      disabled={merchantTransactionLoading ? true : false}
      >
        Export to CSV
      </Button>

    </div>
  )
}

export default TransactionsReportFilter